// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-filter--language-content{width:auto}.lad-filter--language-content .el-checkbox{margin-right:0;text-transform:capitalize;line-height:1.8}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
